// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--2_BiW","buttonResume":"button-module--button--resume--2dEd5"};